import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FrPostfixPipe } from './fr-postfix.pipe';

@NgModule({
  declarations: [FrPostfixPipe],
  imports: [CommonModule],
  exports: [FrPostfixPipe],
})
export class FrPostfixModule {}
